module.exports = new __parcel__URL__("waves-fc.64222fba.png").toString();